export const ENDPOINTS = {
  ROOT: 'https://localhost:3000/',
}
